<div class="justify-center px-[30px] py-[20px]" isOpen="true">
  <div class="flex flex-col items-center gap-[10px]">
    <ark-lib-icon-name name="success"></ark-lib-icon-name>
    <div>
      <h3 class="text-center">{{ invitationMessage }}</h3>
    </div>
    <div>
      <p class="text-center text-sm">
        Each Member will have 7 days to accept the invitation.
      </p>
    </div>
  </div>
</div>
